import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import SectionTitle from '../../elements/section-title/SectionTitle';
import { FaCompress, FaCode, FaGlobe } from 'react-icons/fa';


const WhyChooseOne = () => {
    return (
      <div className="section-padding bg-color-light">
        <div className="container">
            <div className="row">
            <div className="col-lg-6">
                <div className="why-choose-us">
                <SectionTitle 
                    subtitle="Qui sont nos locataires ?"
                    title="Des professionnels en déplacement"
                    description="Nos locataires sont des salariés, des fournisseurs et/ou des cadres d'entreprises qui sont en déplacement professionnel et ont besoin d'un logement pour quelques jours ou semaines."
                    textAlignment="heading-left"
                    textColor=""
                />
                    <Accordion defaultActiveKey="1">
                        <Accordion.Item eventKey="1">
                            <Accordion.Header><FaCompress /> Salariés en mission</Accordion.Header>
                            <Accordion.Body>
                            Nous accueillons également des salariés qui travaillent de manière permanente dans la région et ont besoin d'un logement pour une période d'essai ou en attendant l'achat de leur futur logement.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header><FaCode /> Logement idéal</Accordion.Header>
                            <Accordion.Body>
                            Nous les aidons à trouver le logement idéal pour leur séjour, tout en vous garantissons un loyer sans retard.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header><FaGlobe /> Sécurité garantie</Accordion.Header>
                            <Accordion.Body>
                            Tous nos locataires sont vérifiés et sélectionnés avec soin pour assurer la tranquillité de votre bien immobilier.
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>
            <div className="col-xl-5 col-lg-6 offset-xl-1">
                <div className="why-choose-us mb--30">
                <div className="why-choose-thumb">
                    <img src={process.env.PUBLIC_URL + "/images/about/about-2.png"} alt="Office" />
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>

    )
}

export default WhyChooseOne;